import { ComplexValue } from 'app/types-shared';
import { CodetableAccess } from './types-store';

export const ACTION = {
  REQUEST_CODETABLE_ACCESS: 'MANAGE_OPTIONS:REQUEST_CODETABLE_ACCESS',
  RECEIVE_CODETABLE_ACCESS: 'MANAGE_OPTIONS:RECEIVE_CODETABLE_ACCESS',
  FAIL_CODETABLE_ACCESS: 'MANAGE_OPTIONS:FAIL_CODETABLE_ACCESS',

  REQUEST_HIERARCHY: 'MANAGE_OPTIONS:REQUEST_HIERARCHY',
  RECEIVE_HIERARCHY: 'MANAGE_OPTIONS:RECEIVE_HIERARCHY',
  FAIL_HIERARCHY: 'MANAGE_OPTIONS:FAIL_HIERARCHY',

  FORBIDDEN_ACCESS: 'MANAGE_OPTIONS:FORBIDDEN_ACCESS'

};

export class RequestCodetableAccess {
  public type: string = ACTION.REQUEST_CODETABLE_ACCESS;
  constructor(public codetableId: number) {
  }
}

export class ReceiveCodetableAccess {
  public type: string = ACTION.RECEIVE_CODETABLE_ACCESS;
  constructor(public codetableId: number, public codetableAccess: CodetableAccess) {
  }
}

export class FailCodetableAccess {
  public type: string = ACTION.FAIL_CODETABLE_ACCESS;
  constructor(public codetableId: number) {
  }
}

export class RequestHierarchy {
  public type: string = ACTION.REQUEST_HIERARCHY;
}

export class ReceiveHierarchy {
  public type: string = ACTION.RECEIVE_HIERARCHY;
  constructor(public hierarchy: ComplexValue<number>[]) {
  }
}

export class FailHierarchy {
  public type: string = ACTION.FAIL_HIERARCHY;
}

export class ForbiddenAccess {
  public type: string = ACTION.FORBIDDEN_ACCESS;
}
